import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-get-app',
  templateUrl: './get-app.component.html',
  styleUrls: ['./get-app.component.css']
})
export class GetAppComponent implements OnInit {

  isIOS: boolean;
  isAndroid: boolean;
  showQRCode: boolean;
  qrCodeUrl = 'https://cardbro.cardcompact.com/get';
  utmParams: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.extractUtmParams();
    this.checkDevice();
  }

  extractUtmParams(): void {
    const params = this.route.snapshot.queryParams;
    const utmSource = params['utm_source'] ? `utm_source=${params['utm_source']}` : '';
    const utmMedium = params['utm_medium'] ? `utm_medium=${params['utm_medium']}` : '';
    const utmCampaign = params['utm_campaign'] ? `utm_campaign=${params['utm_campaign']}` : '';
    const utmTerm = params['utm_term'] ? `utm_term=${params['utm_term']}` : '';
    const utmContent = params['utm_content'] ? `utm_content=${params['utm_content']}` : '';

    const utmArray = [utmSource, utmMedium, utmCampaign, utmTerm, utmContent].filter(param => param);
    this.utmParams = utmArray.length ? '?' + utmArray.join('&') : '';

    // Append utmParams to QR code URL
    this.qrCodeUrl += this.utmParams;
  }

  checkDevice(): void {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      this.isIOS = true;
      this.redirectToAppStore();
    } else if (/android/i.test(userAgent)) {
      this.isAndroid = true;
      this.redirectToPlayStore();
    } else {
      this.showQRCode = true;
    }
  }

  redirectToAppStore(): void {
    window.location.href = `https://apps.apple.com/de/app/king/id1577565747${this.utmParams}`;
  }

  redirectToPlayStore(): void {
    window.location.href = `https://play.google.com/store/apps/details?id=com.cardcompact.app${this.utmParams}`;
  }
}
